import { Server, Shield, Cloud, HardDrive, ArrowRight } from "lucide-react";

export default function ArchitectureDiagram() {
  const nodes = [
    { icon: Server, title: "Proxmox VE", sub: "Your cluster", color: "text-slate-200", ring: "border-slate-700" },
    { icon: Shield, title: "Encrypted Link", sub: "TLS / WireGuard", color: "text-cyan-300", ring: "border-cyan-500/40" },
    { icon: Cloud, title: "ZettaKeep Cloud", sub: "Managed PBS", color: "text-cyan-300", ring: "border-cyan-500/40" },
    { icon: HardDrive, title: "Offsite Backups", sub: "Isolated datastore", color: "text-emerald-300", ring: "border-emerald-500/40" },
  ];
  return (
    <div className="relative rounded-2xl border border-slate-800 bg-slate-900/40 p-5 sm:p-8">
      <div className="flex flex-col items-stretch gap-4 md:flex-row md:items-center">
        {nodes.map((n, i) => (
          <div key={n.title} className="flex flex-1 items-center gap-4 md:flex-col md:gap-3">
            <div className={`flex h-16 w-16 shrink-0 items-center justify-center rounded-xl border ${n.ring} bg-[#06080D]`}>
              <n.icon className={`h-7 w-7 ${n.color}`} />
            </div>
            <div className="md:text-center">
              <div className="font-display text-sm font-semibold text-slate-100">{n.title}</div>
              <div className="font-mono text-xs text-slate-500">{n.sub}</div>
            </div>
            {i < nodes.length - 1 && (
              <ArrowRight className="ml-auto h-5 w-5 shrink-0 text-cyan-500/60 md:ml-0 md:hidden" />
            )}
          </div>
        ))}
      </div>
      <svg className="pointer-events-none absolute left-0 top-1/2 hidden w-full -translate-y-1/2 md:block" height="2" style={{ zIndex: -1 }} />
    </div>
  );
}
